package one.healthium.promo_banner.ui

import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import one.healthium.domain.user.UserInteractor
import one.healthium.ui.common.vm.BaseViewModel
import one.primehealth.app.BaseAppConfig
import one.primehealth.app.TargetPlatform
import one.primehealth.app.targetPlatform

internal class PromoBannerViewModel(
    private val userInteractor: UserInteractor,
    private val appConfig: BaseAppConfig
) : BaseViewModel() {

    private val _state = MutableStateFlow(PromoBannerUiState())
    val state = _state.asStateFlow()

    fun showBanner() {
        if (targetPlatform() != TargetPlatform.Web) return

        launch {
            val user = userInteractor.getUser()
            val url = buildPromoBannerUrl(user.id)
            delay(5000)
            _state.update { it.copy(bannerData = PromoBannerData(url = url)) }
        }
    }

    private fun buildPromoBannerUrl(userId: String): String {
        return "${appConfig.oneLinkBaseUrl}?deep_link_value=wu&deep_link_sub1=$userId"
    }
}
